// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  backendDomain: 'https://api.rawnest.in',
  // backendDomain: 'http://localhost:3000',
  // wsDomain: 'ws://localhost:8080',
  // frontendDomain: 'https://serveasy.rawnest.in',
  frontendDomain:
    'https://4200-kanavbhatia-inventorysy-6fshwu70ezl.ws-us116.gitpod.io/',
  // frontendDomain: 'http://localhost:4200',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
